import React, { useEffect, useId, useRef, useState } from 'react';
import cx from '../utils/cx';
import styles from './Navbar.module.css';

// Disclosure menu: opens on hover (pointer devices) or click/tap, closes on outside click, Escape or blur.
const NavDropdown = ({ label, ariaLabel, align = 'start', triggerClassName, children }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const menuId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const handleBlur = (event) => {
    if (!rootRef.current?.contains(event.relatedTarget)) setOpen(false);
  };

  return (
    <div ref={rootRef} className={styles.dropdown} data-open={open} onBlur={handleBlur}>
      <button
        type="button"
        className={triggerClassName || styles.navLink}
        aria-expanded={open}
        aria-controls={menuId}
        aria-label={ariaLabel}
        onClick={() => setOpen((value) => !value)}
      >
        {label}
      </button>
      {/* Any click inside the menu (link or button) closes it. */}
      <ul id={menuId} className={cx(styles.menu, align === 'end' && styles.menuEnd)} onClick={() => setOpen(false)}>
        {children}
      </ul>
    </div>
  );
};

export default NavDropdown;
